import { getWordPressProps, WordPressTemplate } from '@faustwp/core';
import appConfig from '../app.config';

export default function Page(props) {
  return <WordPressTemplate {...props} />;
}

export async function getStaticProps(ctx) {
  // return await getWordPressProps({ ctx });

  // if using WPGraphQL Smart Cache, uncomment this
  return { ...(await getWordPressProps({ ctx })), revalidate: appConfig.revalidate }


}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}
